import './App.css';
import { Toaster } from 'react-hot-toast';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';  // useNavigate is imported here
import logo from './Assets/Images/logo_fityuk.webp'
import bgheader from './Assets/Images/bgheader.webp'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import PageVenueList from './Pages/Venue/Index';
import PageVenueDetail from './Pages/Venue/Detail';
import PageCheckout from './Pages/Checkout/Form';
import PageReviewForm from './Pages/Review/Form';
import AboutUs from './Pages/AboutUs/Index';
import LearnMore from './Pages/LearnMore/Index';
import { useState } from 'react';
import { FaInstagram, FaFacebook, FaTwitter, FaWhatsapp, FaMapMarkerAlt, FaMap, FaLocationArrow } from "react-icons/fa";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

function App() {
  const containerClassName = "max-w-5xl mx-auto w-full";
  const navigate = useNavigate();  // useNavigate hook to navigate programmatically
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querySearch = queryParams.get('search') ?? "";
  const [search, setSearch] = useState(querySearch);

  const socialLinks = {
    instagram: "https://instagram.com/padel.yuk",
    facebook: "https://facebook.com/yourprofile",
    twitter: "https://twitter.com/yourprofile",
  };
  

  // Handle Enter key press for search
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      window.location = `/?search=${search}`;
    }
  };

  return (
    <PhotoProvider>
    <div className='flex flex-col min-h-screen'>
      <header className="bg-white shadow-md p-1 sticky top-0 z-50 flex items-center justify-center">
        <a href="/">
          <img
            src={logo}
            alt="W-Community Logo"
            className='w-[120px] m-2'
          />
        </a>

        <label className="relative flex w-1/5 text-gray-400 focus-within:text-gray-600 ml-6 hidden lg:inline-block ">
          <input
            type="text"
            className='pl-3 flex-grow w-full text-xs bg-[#F5F5F5] rounded-md py-1.5 px-4 focus:outline-none'
            placeholder="Cari Lapang"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyPress} // Listen for Enter key press
          />
          <MagnifyingGlassIcon className='w-6 bg-[#CFCFCF] p-1.5 rounded-lg absolute top-1/2 transform -translate-y-1/2 right-2 text-white' />
        </label>
      </header>

      <div className="flex relative">
        {/* Background Image */}
        <img
          src={bgheader}
          className="w-full absolute top-0 left-0 object-cover z-0"
          alt="Background"
        />

        <div className="flex flex-col flex-1 relative z-1">
          {/* Background Wrapper */}
          <div className={`${containerClassName} font-nunito mt-16 mx-4 mb-8 flex-1 p-6 `}>
            <Toaster />

            {/* Router Setup */}
            <Routes>
              <Route path="/" element={<PageVenueList />} />
              <Route path="/details/:id" element={<PageVenueDetail />} />
              <Route path="/checkout" element={<PageCheckout />} />
              <Route path="/review/:id" element={<PageReviewForm />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/learn-more" element={<LearnMore />} />
            </Routes>
          </div>
        </div>
      </div>

      <footer className="p-6 mt-auto flex flex-col sm:flex-row max-w-5xl mx-auto text-[12px]">
        <div className='flex flex-col sm:w-1/3 mb-4 sm:mb-0'>
          <a href="/">
            <img
              src={logo}
              width="120px"
            />
          </a>
          <p className="mt-2 cursor-pointer flex gap-2" onClick={()=>{
            window.open("https://maps.app.goo.gl/VVc9VTud5gWBSG8A6");
          }}>

      <FaMapMarkerAlt className="text-2xl print:hidden ml-0" /> {/* Map Marker */}
      {/* <FaMap /> */}
      {/* <FaLocationArrow /> */}
          Jl. Cempaka Putih Tengah XV No.1-65, Cemp. Putih Tim., Kec. Cemp. Putih, Jakarta, Daerah Khusus Ibukota Jakarta 10510
          </p>
          <p className="font-semibold cursor-pointer flex items-center text-green-600 gap-1 mt-2" onClick={()=>{
            window.open("https://wa.me/+628551811115");
          }}>
            
            <FaWhatsapp className="text-green-500 text-base print:hidden" />
                  <span>+62 855-1811-115</span>
                  </p>
        </div>

        <div className='flex flex-row sm:w-1/3 justify-between sm:pl-6'>
          <div className='flex flex-col sm:w-1/2'>
            <p>Tentang Kami</p>
            <p className='mt-1'>Kebijakan & Privasi</p>
            <p className='mt-1'>Syarat & Ketentuan</p>
          </div>
          <div className='flex flex-col sm:w-1/2'>
            <p>Pusat Bantuan</p>
            <p className='mt-1'>FAQ</p>
          </div>
        </div>

        <div className='flex flex-col sm:w-1/3 sm:pl-6 mt-4 sm:mt-0'>
          <p>Temukan dan Ikuti Kami!</p>
          <div className="flex gap-4 mt-2">
      {/* Instagram */}
      <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className='flex items-center gap-1 font-semibold '>
        <FaInstagram className="text-pink-500 text-2xl hover:opacity-80" /> @padel.yuk
      </a>

      {/* Facebook */}
      {/* <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
        <FaFacebook className="text-blue-600 text-2xl hover:opacity-80" />
      </a> */}

      {/* Twitter */}
      {/* <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
        <FaTwitter className="text-blue-400 text-2xl hover:opacity-80" />
      </a> */}
    </div>
        </div>
      </footer>
    </div>
    </PhotoProvider>
  );
}

export default App;
